/**
 * Labels for date-ONLY strings ("2026-09-18"). A date-only label has no timezone, so the string is
 * parsed directly and never round-tripped through `Date` -- `new Date('YYYY-MM-DD')` plus local
 * getters reads as the previous day west of Greenwich.
 */
export const MONTHS = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

/** "2026-09-18" -> "Sep 18" */
export const shortDate = (iso) => {
  const [, m, d] = String(iso).split('-');
  return `${MONTHS[Number(m) - 1]} ${Number(d)}`;
};
